import React from 'react'
import PatientSearchModal from './PatientSearchModal'

const PatientAdmissionSearchModal = (props) => <PatientSearchModal {...props} admitMode />

export default PatientAdmissionSearchModal
